import Verification from "routes/Verification";

const varificationRouter = [
    {
        path: "varification",
        element: <Verification />,
    },
];

export default varificationRouter;
